import { useState } from 'react';
import type { FC, ReactNode } from 'react';

import classNames from 'classnames';

import { CardItem } from 'src/app/components/Elements/Card';

import styles from './styles.module.scss';

const InfoCardItem: FC<{ info: ReactNode }> = ({ children, info }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <CardItem noDivider={isOpen} className={classNames(styles.component, styles._specific)}>
      <div className={classNames(styles.main, { [styles.open]: isOpen })}>
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            setIsOpen(!isOpen);
          }}
        >
          {children}
        </a>
      </div>
      {isOpen && (
        <div className={styles.itemInfo}>
          <div className={styles.itemInfoTriangle} />
          <div className={styles.itemInfoBody}>
            <span className={styles.itemInfoBodyText}>{info}</span>
          </div>
        </div>
      )}
    </CardItem>
  );
};

export default InfoCardItem;
